import gql from 'graphql-tag'
import useQuery from 'components/UseQuery'

const GET_USER_ORGANIZATION = gql`
	query user($id: ID!, $topic: String) {
		user(id: $id) {
			organization: main_organization {
				id
				name
				opt_ins: published_opt_ins {
					id
					name
					text
				}
				opt_in_id
				opt_in_default_behaviors
				default_phone_greeting
				default_phone_closing
				waitlist_phone_closing
				operator_notes
				hide_user_campaign_additional_questions
				questions: campaign_additional_questions_by_topic(topic: $topic) {
					question
					options
				}
				block_custom_emails
				block_custom_sms
			}
		}
	}
`

export const useOrganization = (user_id, variables = {}) => {
	const {
		data: { user },
	} = useQuery(GET_USER_ORGANIZATION, {
		variables: { id: user_id, ...variables },
		default_data: { user: {} },
		skip: !user_id,
	})

	return user?.organization
}

export default useOrganization
